import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Paper,
  Container,
} from "@mui/material";
import BarChartIcon from '@mui/icons-material/BarChart';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import GroupMasterHelp from "../../../Helper/SystemmasterHelp";

const ProfitLoss = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [UptoDate, setUptoDate] = useState("");
  const AccountYear = sessionStorage.getItem("Accounting_Year");
  const [loading, setLoading] = useState(false);

  const [groupCode, setGroupCode] = useState('');
  const [gcId, setGCID] = useState('');
  const [groupName, setGroupName] = useState('');

  useEffect(() => {
    if (AccountYear) {
      const dates = AccountYear.split(" - ");
      if (dates.length === 2) {
        setFromDate(dates[0]);
        setToDate(dates[1]);
        setUptoDate(dates[1]);
      }
    }
  }, [AccountYear]);


  const handleGetReportClick = (e) => {
    e.preventDefault();
    if (!groupCode) {
      setGroupCode('');
      setGCID('');
      setGroupName('');
    }
    setLoading(true);
    setTimeout(() => {
      const url = `/ProfitLoss-Report?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&gcid=${encodeURIComponent(gcId)}&groupCode=${encodeURIComponent(groupCode)}&groupName=${encodeURIComponent(groupName)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
      // window.location.reload();
    }, 500);
  };

  const handleBalanceSheetReportClick = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      const url = `/Balancesheet-Report?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&fromDate=${encodeURIComponent(fromDate)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
    }, 500);
  };


  const handleGroupCode = (code, accoid, HSN, name) => {
    if (!code) {
      setGroupCode('');
      setGCID('');
      setGroupName('');
    } else {
      setGroupCode(code);
      setGCID(accoid);
      setGroupName(name);
    }
  };

  return (
    <div className=" mt-5">
      <div className="p-4 mx-auto" style={{ maxWidth: "800px" }}>
        <Container maxWidth="sm">
          <Paper elevation={3} sx={{ p: 4, mt: 6 }}>
            <Typography variant="h6"
              component="h1"
              gutterBottom
              sx={{
                textAlign: 'center',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                color: '#2c3e50',
                marginBottom: '30px',
                padding: '12px 0',
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: '0',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '80px',
                  height: '4px',
                  background: 'linear-gradient(90deg, #3498db, #2ecc71)',
                  borderRadius: '2px',
                  animation: 'underlineGrow 0.5s ease-out forwards'
                },
                '@keyframes underlineGrow': {
                  '0%': { width: '0' },
                  '100%': { width: '80px' }
                }
              }}>
              Profit Loss/Balance Sheet
            </Typography>

            <Box component="form" onSubmit={handleGetReportClick} mt={5}>
              <Grid container spacing={3} justifyContent="center">
                <Grid item xs={7}>
                  <TextField
                    fullWidth
                    label="Upto Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={UptoDate}
                    onChange={(e) => setUptoDate(e.target.value)}
                    sx={{ maxWidth: 300 }}
                  />
                </Grid>

                <Grid item xs={7}>
                  <TextField
                    fullWidth
                    label="From Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </Grid>

                <Grid item xs={7}>
                  <TextField
                    fullWidth
                    label="To Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </Grid>
{/* 
                <div className="receiptpaymentdiv" style={{ marginTop: '10px', marginLeft: '-10px' }}>
                  <label htmlFor="Group_Code" className="receiptpaymentlabel">
                    Group Code :
                  </label>
                  <div className="receiptpayment-col">
                    <div className="receiptpayment-form-group">
                      <GroupMasterHelp
                        onAcCodeClick={handleGroupCode}
                        CategoryName={groupName}
                        CategoryCode={groupCode}
                        SystemType="C"
                        name="Group_Code"
                      />
                    </div>
                  </div>
                </div> */}

                <Grid item xs={12} container justifyContent="center" spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="success"
                      onClick={handleGetReportClick}
                      startIcon={<BarChartIcon />}
                      sx={{
                        padding: '12px 16px',
                        fontSize: '1rem',
                        fontWeight: 600,
                        boxShadow: 3,
                        '&:hover': {
                          boxShadow: 6,
                          transform: 'scale(1.02)',
                          backgroundColor: '#43a047',
                        },
                        transition: 'all 0.3s ease',
                      }}
                    >
                      Profit & Loss
                    </Button>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={handleBalanceSheetReportClick}
                      startIcon={<AccountBalanceIcon />}
                      sx={{
                        padding: '12px 16px',
                        fontSize: '1rem',
                        fontWeight: 600,
                        boxShadow: 3,
                        '&:hover': {
                          boxShadow: 6,
                          transform: 'scale(1.02)',
                          backgroundColor: '#1565c0',
                        },
                        transition: 'all 0.3s ease',
                      }}
                    >
                      Balance Sheet
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Container>
      </div>
    </div>
  );
};

export default ProfitLoss;
